// Central source of all blog posts
export const blogPosts = [
  {
    id: 1,
    title: "How to Secure $5M Trade Finance in 72 Hours",
    slug: "secure-5m-trade-finance-72-hours",
    excerpt: "Discover the step-by-step process we use to approve large trade finance deals in record time. Real case study included.",
    content: `
      <p>Full HTML content goes here...</p>
      <h2>Understanding Trade Finance</h2>
      <p>More content...</p>
    `,
    featuredImage: "/assets/images/micro-finance.jpg",
    category: "Trade Finance",
    tags: ["Line of Credit", "Trade credit and finance", "Fast Funding", "trade finance", "Bank Guarantee", "Bank Note", "Letters of Credit", "Standby Letters of Credit (SBLC)", "Case Study"],
    authorId: 1,
    publishDate: "2025-03-15",
    lastUpdated: "2025-03-20",
    readTime: 8,
    views: 1250,
    featured: true,
    seo: {
      metaTitle: "How to Secure $5M Trade Finance in 72 Hours | Trinity Financing",
      metaDescription: "Learn our proven 72-hour trade finance approval process. Step-by-step guide with real $5M case study.",
      keywords: ["trade finance", "Line of Credit", "Trade credit and finance", "Bank Guarantee", "Bank Note", "Letters of Credit", "Standby Letters of Credit (SBLC)",  "fast funding", "letter of credit", "business loans"]
    }
  },
  {
    id: 2,
    title: "LPO Financing: Complete Guide for Manufacturers",
    slug: "lpo-financing-guide-manufacturers",
    excerpt: "Everything manufacturers need to know about using LPO financing to fulfill large orders without straining cash flow.",
    content: `<p>Full content...</p>`,
    featuredImage: "/assets/images/develpoment-funds.jpg",
    category: "LPO Financing",
    tags: ["LPO", "Manufacturing", "Business Loan", "Contract Financing", "Working Capital", "Financial Consultant", "Trade & Export Finance", "Corporate & Business Financing", "Project Financing"],
    authorId: 2,
    publishDate: "2025-03-10",
    lastUpdated: "2025-03-10",
    readTime: 10,
    views: 890,
    featured: false,
    seo: {
      metaTitle: "LPO Financing Guide for Manufacturers | Trinity Financing",
      metaDescription: "Complete guide to LPO financing for manufacturing businesses. Learn how to turn purchase orders into working capital.",
      keywords: ["LPO financing", "purchase order financing",  "manufacturing loans"]
    }
  },
  // Add more posts...
];

// Helper functions
export const getFeaturedPosts = () => blogPosts.filter(post => post.featured);
export const getPostBySlug = (slug) => blogPosts.find(post => post.slug === slug);
export const getPostsByCategory = (category) => blogPosts.filter(post => post.category === category);
export const getRecentPosts = (count = 5) => [...blogPosts].sort((a, b) => 
  new Date(b.publishDate) - new Date(a.publishDate)
).slice(0, count);